// Initialize the global ReelMetrics namespace
// This must be imported before any other legacy files that use ReelMetrics
var ReelMetrics = ReelMetrics || {};
window.ReelMetrics = ReelMetrics;
